import React from 'react';
import { TouchableOpacity } from 'react-native';
import ChevronRightSVG from '~/assets/svgs/chevron-right.svg';
import colors from '~/assets/themes/colors';

export interface ChevronButtonProps {
  onPress: () => void;
}

const ChevronButton: React.FC<ChevronButtonProps> = ({ onPress }) => {
  return (
    <TouchableOpacity
      onPress={onPress}
      hitSlop={{ bottom: 16, left: 16, right: 16, top: 16 }}
    >
      <ChevronRightSVG color={colors.gray[400]} />
    </TouchableOpacity>
  );
};

export default ChevronButton;
